import { Factory } from 'rosie';

Factory.define('Search').attr('name', 'SEARCH');

Factory.define('SearchWithDefaults').extend('Search');
